import { render, staticRenderFns } from "./Relax.vue?vue&type=template&id=c6b20952"
import script from "./Relax.vue?vue&type=script&lang=js"
export * from "./Relax.vue?vue&type=script&lang=js"
import style0 from "./Relax.vue?vue&type=style&index=0&id=c6b20952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports